import { useTranslation } from 'react-i18next';
import { Paragraph, Headings } from '@sentara-health/optimahealth_web';

function PasswordInfoOverlay() {
  const { t } = useTranslation();
  return (
    <>
      <Headings
        level={5}
        text={t('resetPassword.passwordTooltipText')}
        variant="bold"
        data-testid="passwordTooltipHeader"
        className="mb-4"
      />
      <div className="row my-2">
        <div className="col-12">
          <Paragraph
            text=
            {t('resetPassword.passwordRequirementsOne')}
            variant="regular"
            className="discList lh-1"
            data-testid="passwordRequirementsOne"
          />
          <Paragraph
            text={t('resetPassword.passwordRequirementsSecond')}
            variant="regular"
            className="discList lh-1"
            data-testid="passwordRequirementsSecond"
          />
          <Paragraph
            text={t('resetPassword.passwordRequirementsThree')}
            variant="regular"
            className="discList lh-1"
            data-testid="passwordRequirementsThree"
          />
          <Paragraph
            text={t('resetPassword.passwordRequirementsFour')}
            variant="regular"
            className="discList lh-1"
            data-testid="passwordRequirementsFour"
          />
          <Paragraph
            text={t('resetPassword.passwordRequirementsFive')}
            variant="regular"
            className="discList lh-1"
            data-testid="passwordRequirementsFive"
          />
          <Paragraph
            text={t('resetPassword.passwordRequirementsSix')}
            variant="regular"
            className="discList lh-1"
            data-testid="passwordRequirementsSix"
          />
          <Paragraph
            text={t('resetPassword.passwordRequirementsSeven')}
            variant="regular"
            className="discList lh-1"
            data-testid="passwordRequirementsSeven"
          />
          <Paragraph
            text={t('resetPassword.passwordRequirementsEight')}
            variant="regular"
            className="discList lh-1"
            data-testid="passwordRequirementsEight"
          />
        </div>
      </div>
      <Paragraph
        text={t('resetPassword.passwordRequirementsInfo')}
        variant="regular"
        data-testid="passwordTooltipHeaderEight"
      />
    </>
  );
}

export default PasswordInfoOverlay;
